import {
    FiltrosDeInstalacaoProduto,
    FiltroInstalacaoProduto,
    FiltroAlteracaoEstado,
    FiltroMetadata,
    FiltroParametroInstalacao,
    Metadata
} from './../../../model/filtros';
import {CatalogoApiService} from './../../../service/api/catalogo.api';
import {DetalhamentoApiService} from './../../../service/api/detalhamento.api';
import {Component, HostListener} from '@angular/core';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import {InstalacaoProduto, ItemConfiguracao, Cliente} from '../../../model/catalogo';
import {ModalService} from '../../../service/modal.service';
import {PesquisasFiltroApiService} from '../../../service/api/pesquisas-filtro.api';
import {ConstantesApiService} from '../../../service/api/constantes.api';
import {TipoEstado} from '../../../model/constantes';
import {Router} from '@angular/router';
import {GlobalService} from '../../../service/global.service';
import {JQueryStatic} from 'jquery';
import {IMyDpOptions} from 'mydatepicker';

declare var $: JQueryStatic;

@Component({
    selector: 'instalacao-produto',
    templateUrl: './instalacao-produto.component.html',
    styleUrls: ['./instalacao-produto.component.css', '../artefato.css']
})
export class ArtefatoInstalacaoProdutoComponent {

    instalacaoDetalhe: InstalacaoProduto = new InstalacaoProduto();
    instalacoesProduto: Array<InstalacaoProduto> = new Array<InstalacaoProduto>();
    estados: Array<TipoEstado> = new Array<TipoEstado>();
    itensConfiguracao: Array<ItemConfiguracao> = new Array<ItemConfiguracao>();

    pagina: number = 1;
    paginacao: Metadata = new Metadata();

    nome = new FormControl('', []);
    codigo = new FormControl('', []);
    versao = new FormControl('', []);
    descricao = new FormControl('', []);
    estado = new FormControl('', []);
    tipoProduto = new FormControl('', []);
    icVinculado = new FormControl('', []);
    cliente = new FormControl({value: '', disabled: true}, []);

    clienteVinculado = new Cliente();

    nomeParametroInstalacao = new FormControl('', []);
    conteudoParametroInstalacao = new FormControl('', []);

    alteracaoEstado = new FormControl('', []);
    dtInicio = new FormControl('', []);
    dtFim = new FormControl('', []);
    matricula = new FormControl('', []);
    irpagina = new FormControl('', []);
    hoje: Date = new Date();

    constructor(private formBuilder: FormBuilder, private router: Router, private modalService: ModalService, private constantesService: ConstantesApiService,
                public pesquisaService: PesquisasFiltroApiService, private globalService: GlobalService, private detalhamentoApiService: DetalhamentoApiService,
                public catalogoService: CatalogoApiService) {
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event != null) {
            if (event.keyCode === 13) {
                this.filtrarInstalacaoProduto();
            }
        }
    }

    ngOnInit() {
        this.constantesService.buscaTipoEstado(0)
            .subscribe(estados => this.estados = estados as Array<TipoEstado>);
        this.filtrarInstalacaoProduto();
        this.getItensConfiguracao();
        let container = document.getElementById('container-principal');
        container.classList.add('container-maior');
    }

    public myDatePickerOptions: IMyDpOptions = {
        // dateFormat: 'dd/mm/yyyy',
        dateFormat: 'yyyy-mm-dd',
        monthLabels: {
            1: 'Jan',
            2: 'Fev',
            3: 'Mar',
            4: 'Abr',
            5: 'Mai',
            6: 'Jun',
            7: 'Jul',
            8: 'Ago',
            9: 'Set',
            10: 'Out',
            11: 'Nov',
            12: 'Dez'
        },
        dayLabels: {su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab'},
        sunHighlight: true,
        satHighlight: true,
        editableDateField: true,
        todayBtnTxt: 'Hoje',
        firstDayOfWeek: 'su',
        maxYear: this.hoje.getFullYear(),
        openSelectorOnInputClick: true
    };

    ngOnDestroy() {
        let container = document.getElementById('container-principal');
        container.classList.remove('container-maior');
    }

    getItensConfiguracao() {
        let filtros: Array<any> = new Array<any>();
        filtros.push({'filtroItemConfiguracao': {'tipoItemConfiguracao': 1}});
        this.globalService.loading = true;
        this.pesquisaService.filtraItemConfiguracao(filtros)
            .subscribe(
                listaItens => {
                    this.itensConfiguracao = listaItens.sort(function (a, b) {
                        var textA = a.nome;
                        var textB = b.nome;
                        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                    }) as Array<ItemConfiguracao>;
                    this.globalService.loading = false;
                },
                erro => {
                    this.globalService.loading = false;
                    if (erro.status == 404) {
                        this.itensConfiguracao = new Array<ItemConfiguracao>();
                    }
                }
            );
    }

    getTipoCliente(tipo: number) {
        switch (tipo) {
            case 1:
                return 'Usuário Impessoal';
            case 2:
                return 'MCI';
            case 3:
                return 'UOR';
        }
    }

    getNomeCliente(cliente: Cliente) {
        switch (cliente.codTipoCliente) {
            case 1:
                return cliente.userAplicacao.nomeUserAplicacao;
            case 2:
                return cliente.mci.nomeCliente == null ? cliente.mci.codMci : cliente.mci.codMci + ' - ' + cliente.mci.nomeCliente;
            case 3:
                return cliente.uor.nomeDependencia == null ? cliente.uor.codUor : cliente.uor.codUor + ' - ' + cliente.uor.nomeDependencia;
            default:
                return 'Não foi possível recuperar o nome do cliente';
        }
    }

    selecionarCliente() {
        this.modalService.abrirPaginaModal('cliente-modal', {}, {'pesquisar': false},
            'Selecionar Cliente', 'Fechar')
            .subscribe(cliente => {
                if (cliente != null) {
                    this.cliente.setValue(this.getNomeCliente(cliente));
                    this.clienteVinculado = cliente;
                }
            });
    }

    apagarCliente() {
        this.cliente.setValue('');
        this.clienteVinculado = new Cliente();
    }

    detalhesInstalacao(codInstalacao, versao) {
        this.detalhamentoApiService.detalhaInstalacaoProduto(codInstalacao, versao)
            .subscribe(response => {
                    this.instalacaoDetalhe = response;
                    $('#detalheModal').modal('show');
                },
                erro => {
                });
    }

    editarInstalacao(codInstalacao, versao) {
        this.router.navigate(['/artefato-cadastro-instalacao-produto', codInstalacao, versao]);
    }

    excluirInstalacao(codInstalacao, versao) {
        let msgSucesso = 'Instalação de Produto removida com sucesso.';
        let msgErro = 'Ocorreu um erro ao remover a Instalação de Produto.';
        this.catalogoService.removeInstalacaoProduto(codInstalacao, versao)
            .subscribe(
                response => {
                    this.globalService.loading = false;
                    this.modalService.exibirMensagem('Sucesso', msgSucesso, 'Fechar');
                    this.filtrarInstalacaoProduto();
                },
                erro => {
                    this.globalService.loading = false;
                    if (erro.status == 404 || erro.status == 500) {
                        this.modalService.exibirMensagem('Erro', msgErro, 'Fechar');
                    }
                    if (erro.status == 403) {
                        this.modalService.exibirMensagem('Erro', 'Você não possui permissão para efetuar esta operação', 'Fechar');
                    }
                }
            );
    }

    novaInstalacaoProduto() {
        this.router.navigate(['/artefato-cadastro-instalacao-produto']);
    }


    alterarEstado(codigo, versao, tipoOperacao) {

        let msgSucesso = '';
        let msgErro = '';
        let msgAtualizacao = '';

        switch (tipoOperacao) {
            case 'despacha':
                msgSucesso = 'Instalação de Produto despachada com sucesso.';
                msgErro = 'Ocorreu um erro ao despachar a Instalação de Produto.';
                msgAtualizacao = 'Item despachado pelo sistema Administração Web.';
                break;
            case 'aprova':
                msgSucesso = 'Instalação de Produto aprovada com sucesso.';
                msgErro = 'Ocorreu um erro ao aprovar a Instalação de Produto.';
                msgAtualizacao = 'Item aprovado pelo sistema Administração Web.';
                break;
            case 'ativa':
                msgSucesso = 'Instalação de Produto ativada com sucesso.';
                msgErro = 'Ocorreu um erro ao ativar a Instalação de Produto.';
                msgAtualizacao = 'Item ativado pelo sistema Administração Web.';
                break;
            case 'inativa':
                msgSucesso = 'Instalação de Produto inativada com sucesso.';
                msgErro = 'Ocorreu um erro ao inativar a Instalação de Produto.';
                msgAtualizacao = 'Item inativado pelo sistema Administração Web.';
                break;
        }

        this.globalService.loading = true;
        this.catalogoService.alterarEstadoInstalacaoProduto(codigo, versao, tipoOperacao, msgAtualizacao)
            .subscribe(
                response => {
                    this.globalService.loading = false;
                    this.modalService.exibirMensagem('Sucesso', msgSucesso, 'Fechar');
                    this.filtrarInstalacaoProduto();
                },
                erro => {
                    this.globalService.loading = false;
                    if (erro.status == 404 || erro.status == 500) {
                        this.modalService.exibirMensagem('Erro', msgErro, 'Fechar');
                    }
                    if (erro.status == 403) {
                        this.modalService.exibirMensagem('Erro', 'Você não possui permissão para efetuar a operação', 'Fechar');
                    }
                }
            );

    }

    filtrarInstalacaoProduto() {

        this.globalService.loading = true;
        this.pesquisaService.mudarPagina(this.pagina);
        let filtros = this.getFiltros();

        this.pesquisaService.filtraInstalacaoProdutoPaginacao(filtros)
            .subscribe(
                resultado => {
                    this.instalacoesProduto = resultado.instalacoesProduto;
                    this.paginacao = resultado.metadata;
                    this.globalService.loading = false;
                },
                erro => {
                    this.globalService.loading = false;
                    if (erro.status == 404) {
                        this.instalacoesProduto = new Array<InstalacaoProduto>();
                    }
                }
            );

    }

    getFiltros() {

        let filtros = new FiltrosDeInstalacaoProduto();
        let filtroInstalacaoProduto = new FiltroInstalacaoProduto();
        let filtroAlteracaoEstado = new FiltroAlteracaoEstado();
        let filtroMetadata = new FiltroMetadata();

        filtroMetadata.pagina = this.pagina;
        filtroMetadata.porPagina = 10;

        if (this.nome.value != '') {
            filtroInstalacaoProduto.nomeInstalacao = this.nome.value;
        }

        if (this.codigo.value != '') {
            filtroInstalacaoProduto.codigo = this.codigo.value;
        }

        if (this.versao.value != '') {
            filtroInstalacaoProduto.versao = this.versao.value;
        }

        if (this.descricao.value != '') {
            filtroInstalacaoProduto.descricao = this.descricao.value;
        }

        if (this.estado.value != '') {
            filtroInstalacaoProduto.codTipoEstado = this.estado.value;
        }

        if (this.tipoProduto.value != '') {
            filtroInstalacaoProduto.nomeItemConfiguracaoProduto = this.tipoProduto.value;
        }

        if (this.icVinculado.value != '') {
            filtroInstalacaoProduto.itemConfiguracaoVinculado = this.icVinculado.value;
        }

        if (this.cliente.value != '') {
            filtroInstalacaoProduto.clienteVinculado = this.clienteVinculado;
        }

        if (this.nomeParametroInstalacao.value != '' || this.conteudoParametroInstalacao.value != '') {
            let parmInstalacao = new FiltroParametroInstalacao();
            parmInstalacao.nomeParm = this.nomeParametroInstalacao.value;
            parmInstalacao.valorParm = this.conteudoParametroInstalacao.value;
            filtroInstalacaoProduto.parmInstalacao = new Array<FiltroParametroInstalacao>();
            filtroInstalacaoProduto.parmInstalacao.push(parmInstalacao);
        }

        // filtro alteracao estado
        if (this.alteracaoEstado.value != '') {
            filtroAlteracaoEstado.codTipoEstado = this.alteracaoEstado.value;
        }
        if (this.matricula.value != '') {
            filtroAlteracaoEstado.matricula = this.matricula.value;
        }
        if (this.dtInicio.value != '') {
            filtroAlteracaoEstado.dataInicial = this.dtInicio.value.formatted;
        }
        if (this.dtFim.value != '') {
            filtroAlteracaoEstado.dataFinal = this.dtFim.value.formatted;
        }

        filtros.filtroInstalacaoProduto = filtroInstalacaoProduto;
        filtros.filtroAlteracaoEstado = filtroAlteracaoEstado;
        filtros.metadata = filtroMetadata;

        return filtros;
    }

    getEstado(codigo: Number) {
        let estado = this.estados.find(x => x.codigo == codigo);
        if (estado != null) {
            return estado.descricao;
        }
        return '-';
    }

    proximaPagina(desabilitado: string) {
        if (desabilitado == 'true') {
            return false;
        }
        this.pagina++;
        this.filtrarInstalacaoProduto();
    }

    paginaAnterior(desabilitado: string) {
        if (desabilitado == 'true') {
            return false;
        }
        this.pagina--;
        this.filtrarInstalacaoProduto();
    }

    IrparaPargina() {
        if (this.irpagina.value != 0) {
            this.pagina = this.irpagina.value;
            this.filtrarInstalacaoProduto();
        }
    }


    formataData(dt): string {
        var data = new Date(dt);
        return data.toLocaleString();
    }
}



// WEBPACK FOOTER //
// ./src/app/artefato/instalacao-produto/instalacao-produto.component.ts